module.exports = __webpack_public_path__ + "static/media/tronss.6f8f14cb.png";